export type ChatVoiceControl = "gpt-live" | null;

export interface ChatVoiceFeatures {
  control: ChatVoiceControl;
  dictationEnabled: boolean;
}

export function getChatVoiceFeatures(
  gptLiveEnabled: boolean,
  voiceInputEnabled: boolean,
): ChatVoiceFeatures {
  return {
    control: gptLiveEnabled ? "gpt-live" : null,
    dictationEnabled: voiceInputEnabled,
  };
}
